import * as modalWindow from '../../ui-components/editor/modalWindow';

export const initialize = modal => {
  modalWindow.initialize(modal);

  const dismissButton = modal.querySelector('.ui-site-thank-you-modal__button');
  dismissButton.addEventListener('click', () => {
    modalWindow.closeModalWindow(modal);
  });
};

const setTranslations = (modal, translations) => {
  const thankYouModalTitle = modal.querySelector('.ui-site-thank-you-modal__title-text');
  const thankYouModalDescription = modal.querySelector('.ui-site-thank-you-modal__description');
  const thankYouModalInputDescription = modal.querySelector('.ui-site-thank-you-modal__input-description');
  const thankYouModalButton = modal.querySelector('.ui-site-thank-you-modal__button-text');
  const thankYouModalInput = modal.querySelector('.ui-site-input__input');
  const thankYouModalShowSubscribersButton = modal.querySelector('.ui-site-thank-you-modal__button-open-list .ui-site-thank-you-modal__button-text');

  thankYouModalTitle.innerText = translations['client.thank_you_modal.title'];
  thankYouModalDescription.innerHTML = translations['client.thank_you_modal.description'];
  thankYouModalInputDescription.innerText = translations['client.thank_you_modal.input.description'];
  thankYouModalButton.innerText = translations['client.thank_you_modal.button.default.text'];
  thankYouModalInput.placeholder = translations['client.thank_you_modal.input.placeholder'];
  thankYouModalShowSubscribersButton.innerText = translations['client.thank_you_modal.button.show_list'];
};

export default async ({ translations }) => {
  const thankYouModal = document.querySelector('.ui-site-thank-you-modal');
  if (!thankYouModal) {
    return;
  }
  setTranslations(thankYouModal, translations);
  initialize(thankYouModal);
};
